import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { dashboardFichasAPI, informesAPI, tiposClientesAPI, tiposProveedoresAPI, clientesAPI, proveedoresAPI, usuariosAPI, cajasAPI, cuentasBancariasAPI, gruposAPI, formasPagoAPI } from '../services/api';
import { toast } from 'react-toastify';
import { SelectorMultiFicha } from '../components/SelectorMultiFicha';
import '../Clientes.css';
import '../components/SelectorColumnas.css';

const SECTION_LABELS = {
  clientes: 'Clientes',
  proveedores: 'Proveedores',
  empleados: 'Empleados',
  fondos: 'Fondos',
};

const DashboardFichaForm = ({ origen }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const basePath = origen ? `/${origen}/fichas` : '/dashboard-fichas';
  const sectionLabel = origen ? SECTION_LABELS[origen] : null;
  const [loading, setLoading] = useState(false);
  const [fuentes, setFuentes] = useState([]);
  const [tiposClientes, setTiposClientes] = useState([]);
  const [tiposProveedores, setTiposProveedores] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [cajas, setCajas] = useState([]);
  const [cuentasBancarias, setCuentasBancarias] = useState([]);
  const [grupos, setGrupos] = useState([]);
  const [formasPago, setFormasPago] = useState([]);
  const [formData, setFormData] = useState({
    titulo: '',
    origen: origen || 'clientes',
    operacion: 'contar',
    clave_metrica: '',
    config: {},
    mostrar_en_dashboard: true,
    activo: true,
    orden: 0,
  });

  useEffect(() => {
    let cancelled = false;
    informesAPI.fuentesMetricas(origen || undefined).then((res) => {
      if (!cancelled && res.success && Array.isArray(res.data)) {
        setFuentes(res.data);
        if (res.data.length > 0 && !id) {
          const first = res.data[0];
          setFormData((prev) => (prev.clave_metrica ? prev : { ...prev, clave_metrica: first.id, origen: first.origen }));
        }
      }
    }).catch(() => toast.error('Error al cargar fuentes de métricas'));
    return () => { cancelled = true; };
  }, [id, origen]);

  useEffect(() => {
    let cancelled = false;
    tiposClientesAPI.getAll().then((res) => {
      if (!cancelled && res.success && res.data) setTiposClientes(res.data);
    }).catch(() => {});
    return () => { cancelled = true; };
  }, []);
  useEffect(() => {
    let cancelled = false;
    tiposProveedoresAPI.getAll().then((res) => {
      if (!cancelled && res.success && res.data) setTiposProveedores(res.data);
    }).catch(() => {});
    return () => { cancelled = true; };
  }, []);
  useEffect(() => {
    let cancelled = false;
    clientesAPI.getAll({ activo: true }).then((res) => {
      if (!cancelled && res.success && res.data) setClientes(res.data);
    }).catch(() => {});
    return () => { cancelled = true; };
  }, []);
  useEffect(() => {
    let cancelled = false;
    proveedoresAPI.getAll({ activo: true }).then((res) => {
      if (!cancelled && res.success && res.data) setProveedores(res.data);
    }).catch(() => {});
    return () => { cancelled = true; };
  }, []);
  useEffect(() => {
    let cancelled = false;
    usuariosAPI.getAll().then((res) => {
      if (!cancelled && res.success && res.data) setUsuarios(res.data);
    }).catch(() => {});
    return () => { cancelled = true; };
  }, []);
  useEffect(() => {
    let cancelled = false;
    cajasAPI.getAll().then((res) => {
      if (!cancelled && res.success && res.data) setCajas(res.data);
    }).catch(() => {});
    return () => { cancelled = true; };
  }, []);
  useEffect(() => {
    let cancelled = false;
    cuentasBancariasAPI.getAll().then((res) => {
      if (!cancelled && res.success && res.data) setCuentasBancarias(res.data);
    }).catch(() => {});
    return () => { cancelled = true; };
  }, []);
  useEffect(() => {
    let cancelled = false;
    gruposAPI.getAll().then((res) => {
      if (!cancelled && res.success && res.data) setGrupos(res.data);
    }).catch(() => {});
    return () => { cancelled = true; };
  }, []);
  useEffect(() => {
    let cancelled = false;
    if (origen === 'fondos' || origen == null) {
      formasPagoAPI.getAll({ activo: true }).then((res) => {
        if (!cancelled && res.success && res.data) setFormasPago(Array.isArray(res.data) ? res.data : []);
      }).catch(() => {});
    }
    return () => { cancelled = true; };
  }, [origen]);

  const loadFicha = useCallback(async () => {
    try {
      const response = await dashboardFichasAPI.obtener(id);
      if (response.success && response.data) {
        const d = response.data;
        let config = d.config;
        if (typeof config === 'string') {
          try {
            config = config ? JSON.parse(config) : {};
          } catch (_) {
            config = {};
          }
        }
        setFormData({
          titulo: d.titulo || '',
          origen: d.origen || 'clientes',
          operacion: d.operacion || 'contar',
          clave_metrica: d.clave_metrica || '',
          config: config || {},
          mostrar_en_dashboard: Boolean(d.mostrar_en_dashboard),
          activo: Boolean(d.activo),
          orden: Number(d.orden) || 0,
        });
      }
    } catch (error) {
      toast.error('Error al cargar la ficha');
      navigate(basePath);
    }
  }, [id, navigate, basePath]);

  useEffect(() => {
    if (id) loadFicha();
  }, [id, loadFicha]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleConfigChange = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      config: { ...prev.config, [key]: value },
    }));
  };

  const fuenteSeleccionada = fuentes.find((f) => f.id === formData.clave_metrica);
  const operacionesDisponibles = fuenteSeleccionada?.operaciones || [];
  const filtrosDisponibles = fuenteSeleccionada?.filtros || [];

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.titulo.trim()) {
      toast.error('El título es obligatorio');
      return;
    }
    if (!formData.clave_metrica) {
      toast.error('Seleccione una fuente de datos');
      return;
    }
    const op = operacionesDisponibles.find((o) => o.id === formData.operacion);
    if (!op) {
      toast.error('Seleccione una operación válida');
      return;
    }
    for (const f of filtrosDisponibles) {
      if (f.requerido && (formData.config[f.id] === undefined || formData.config[f.id] === '')) {
        toast.error(`El campo "${f.nombre}" es obligatorio`);
        return;
      }
    }
    setLoading(true);
    try {
      const payload = {
        titulo: formData.titulo.trim(),
        origen: fuenteSeleccionada?.origen || formData.origen,
        operacion: formData.operacion,
        clave_metrica: formData.clave_metrica,
        config: Object.keys(formData.config).length ? formData.config : null,
        mostrar_en_dashboard: formData.mostrar_en_dashboard,
        activo: formData.activo,
        orden: Number(formData.orden) || 0,
      };
      if (id) {
        const res = await dashboardFichasAPI.actualizar(id, payload);
        if (res.success) {
          toast.success('Ficha actualizada');
          navigate(basePath);
        }
      } else {
        const res = await dashboardFichasAPI.crear(payload);
        if (res.success) {
          toast.success('Ficha creada');
          navigate(basePath);
        }
      }
    } catch (error) {
      toast.error(error.message || 'Error al guardar');
    } finally {
      setLoading(false);
    }
  };

  const getOpcionesParaFiltro = (filtro) => {
    if (filtro.opciones === 'tipos_clientes') {
      return tiposClientes.map((t) => ({ value: t.id, label: t.nombre }));
    }
    if (filtro.opciones === 'tipos_proveedores') {
      return tiposProveedores.map((t) => ({ value: t.id, label: t.nombre }));
    }
    if (filtro.opciones === 'clientes') {
      return clientes.map((c) => ({ value: c.id, label: c.razon_social || c.nombre || `#${c.id}` }));
    }
    if (filtro.opciones === 'proveedores') {
      return proveedores.map((p) => ({ value: p.id, label: p.razon_social || p.nombre || `#${p.id}` }));
    }
    if (filtro.opciones === 'usuarios') {
      return usuarios.map((u) => ({ value: u.id, label: u.nombre || u.username || `#${u.id}` }));
    }
    if (filtro.opciones === 'cajas') {
      return cajas.map((c) => ({ value: c.id, label: c.nombre || `Caja ${c.id}` }));
    }
    if (filtro.opciones === 'cuentas_bancarias') {
      return cuentasBancarias.map((c) => ({ value: c.id, label: c.nombre || c.numero_cuenta || `Cuenta ${c.id}` }));
    }
    if (filtro.opciones === 'grupos') {
      return grupos.map((g) => ({ value: g.id, label: g.nombre || `Grupo ${g.id}` }));
    }
    if (filtro.opciones === 'formas_pago') {
      return formasPago.map((f) => ({ value: f.id, label: f.nombre || `Forma ${f.id}` }));
    }
    if (Array.isArray(filtro.opciones)) return filtro.opciones;
    return [];
  };

  return (
    <div className="clientes">
      <div className="page-header">
        <h1>{id ? 'Editar ficha' : (sectionLabel ? `Nueva ficha de ${sectionLabel}` : 'Nueva ficha del dashboard')}</h1>
        <Link to={basePath} className="btn-secondary">Volver al listado</Link>
      </div>
      <form onSubmit={handleSubmit} className="form-container">
        <div className="form-group">
          <label htmlFor="titulo">Título (visible en la ficha)</label>
          <input
            id="titulo"
            name="titulo"
            type="text"
            value={formData.titulo}
            onChange={handleChange}
            placeholder="Ej: Clientes activos"
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="clave_metrica">Fuente de datos</label>
          <select
            id="clave_metrica"
            name="clave_metrica"
            value={formData.clave_metrica}
            onChange={handleChange}
          >
            <option value="">Seleccione una fuente</option>
            {fuentes.map((f) => (
              <option key={f.id} value={f.id}>{f.nombre}</option>
            ))}
          </select>
          {fuenteSeleccionada && (
            <small className="form-hint">{fuenteSeleccionada.nombre}</small>
          )}
        </div>
        {fuenteSeleccionada && operacionesDisponibles.length > 0 && (
          <div className="form-group">
            <label htmlFor="operacion">Operación</label>
            <select id="operacion" name="operacion" value={formData.operacion} onChange={handleChange}>
              {operacionesDisponibles.map((o) => (
                <option key={o.id} value={o.id}>{o.label}</option>
              ))}
            </select>
            {formData.clave_metrica === 'abonos_cargados_cobrados' && formData.operacion === 'grafico_torta' && (
              <small className="form-hint">
                El gráfico toma los abonos cargados como 100% y muestra la parte cobrada vs pendiente.
              </small>
            )}
          </div>
        )}
        {filtrosDisponibles.map((filtro) => {
          if (filtro.tipo === 'boolean') {
            const val = formData.config[filtro.id];
            const checked = val !== false && val !== 'false' && (val === true || val === 'true' || filtro.default === true);
            return (
              <div key={filtro.id} className="form-group checkbox-group">
                <label className="selector-columnas-label">
                  <input
                    type="checkbox"
                    checked={checked}
                    onChange={(e) => handleConfigChange(filtro.id, e.target.checked)}
                  />
                  <span>{filtro.nombre}</span>
                </label>
              </div>
            );
          }
          if (filtro.tipo === 'number') {
            const esDiasParaFechaCobro = filtro.id === 'dias_vencimiento' || filtro.id === 'dias';
            const esDiasMovil = filtro.id === 'dias_movil';
            const criterioCobro = formData.config.fecha_cobro_criterio;
            const criterioMovil = formData.config.fecha_criterio_movil;
            if (esDiasParaFechaCobro) {
              const mostrarConProximosOUltimos = criterioCobro === 'proximos_x_dias' || criterioCobro === 'ultimos_x_dias';
              if (!mostrarConProximosOUltimos) return null;
            }
            if (esDiasMovil) {
              const mostrarConProximosOUltimos = criterioMovil === 'proximos_x_dias' || criterioMovil === 'ultimos_x_dias';
              if (!mostrarConProximosOUltimos) return null;
            }
            const defaultVal = filtro.default != null ? filtro.default : 30;
            return (
              <div key={filtro.id} className="form-group">
                <label htmlFor={`config_${filtro.id}`}>{filtro.nombre}</label>
                <input
                  id={`config_${filtro.id}`}
                  type="number"
                  min={1}
                  max={365}
                  value={formData.config[filtro.id] ?? defaultVal}
                  onChange={(e) => handleConfigChange(filtro.id, parseInt(e.target.value, 10) || defaultVal)}
                />
              </div>
            );
          }
          if (filtro.tipo === 'date') {
            return (
              <div key={filtro.id} className="form-group">
                <label htmlFor={`config_${filtro.id}`}>{filtro.nombre}</label>
                <input
                  id={`config_${filtro.id}`}
                  type="date"
                  value={formData.config[filtro.id] ?? ''}
                  onChange={(e) => handleConfigChange(filtro.id, e.target.value || null)}
                />
              </div>
            );
          }
          if (filtro.tipo === 'select') {
            const opciones = getOpcionesParaFiltro(filtro);
            const needNumber = ['tipos_clientes', 'tipos_proveedores', 'usuarios', 'cajas', 'cuentas_bancarias', 'grupos', 'formas_pago'].includes(filtro.opciones);
            return (
              <div key={filtro.id} className="form-group">
                <label htmlFor={`config_${filtro.id}`}>{filtro.nombre}</label>
                <select
                  id={`config_${filtro.id}`}
                  value={formData.config[filtro.id] ?? ''}
                  onChange={(e) => {
                    const v = e.target.value;
                    const final = v === '' ? '' : (needNumber ? Number(v) : v);
                    handleConfigChange(filtro.id, final);
                  }}
                >
                  <option value="">(Todos)</option>
                  {opciones.map((opt) => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </div>
            );
          }
          if (filtro.tipo === 'multiselect') {
            const opciones = getOpcionesParaFiltro(filtro);
            const selected = formData.config[filtro.id];
            const selectedIds = Array.isArray(selected) ? selected : (selected != null && selected !== '' ? [selected] : []);
            const useStringValues = opciones.length > 0 && typeof opciones[0].value === 'string';
            return (
              <SelectorMultiFicha
                key={filtro.id}
                titulo={filtro.nombre}
                labelBoton={filtro.nombre}
                opciones={opciones}
                selectedIds={selectedIds}
                onChange={(ids) => handleConfigChange(filtro.id, ids)}
                valueType={useStringValues ? 'string' : 'number'}
              />
            );
          }
          if (filtro.tipo === 'multiselect_cuenta_caja') {
            const opciones = [
              ...cajas.map((c) => ({ value: `caja_${c.id}`, label: c.nombre || `Caja ${c.id}` })),
              ...cuentasBancarias.map((cb) => ({ value: `cuenta_${cb.id}`, label: `${cb.numero_cuenta || cb.nombre || 'Cuenta'}${cb.banco_nombre ? ` (${cb.banco_nombre})` : ''}` })),
            ];
            const selected = formData.config[filtro.id];
            const selectedIds = Array.isArray(selected) ? selected : (selected != null && selected !== '' ? [selected] : []);
            return (
              <SelectorMultiFicha
                key={filtro.id}
                titulo={filtro.nombre}
                labelBoton={filtro.nombre}
                opciones={opciones}
                selectedIds={selectedIds}
                onChange={(ids) => handleConfigChange(filtro.id, ids)}
                valueType="string"
              />
            );
          }
          return null;
        })}
        <div className="form-row">
          <div className="form-group checkbox-group">
            <label className="selector-columnas-label">
              <input
                type="checkbox"
                name="mostrar_en_dashboard"
                checked={formData.mostrar_en_dashboard}
                onChange={handleChange}
              />
              <span>Mostrar en dashboard</span>
            </label>
          </div>
          <div className="form-group checkbox-group">
            <label className="selector-columnas-label">
              <input
                type="checkbox"
                name="activo"
                checked={formData.activo}
                onChange={handleChange}
              />
              <span>Activo</span>
            </label>
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="orden">Orden (opcional)</label>
          <input
            id="orden"
            name="orden"
            type="number"
            min={0}
            value={formData.orden}
            onChange={handleChange}
          />
        </div>
        <div className="form-actions">
          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? 'Guardando...' : (id ? 'Actualizar' : 'Crear ficha')}
          </button>
          <Link to={basePath} className="btn-secondary">Cancelar</Link>
        </div>
      </form>
    </div>
  );
};

export default DashboardFichaForm;
